export const REPORTS_LOGIN_AUTH = 'REPORTS_LOGIN_AUTH';

export const loginAuth = data => ({
  type: REPORTS_LOGIN_AUTH,
  payload: data
});
